/**
 * Defines the constants used by the Constants module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */

export const VUEX_CONSTANTS_INIT			= 'VUEX_CONSTANTS_INIT'
export const VUEX_CONSTANTS_INITIALIZED		= 'VUEX_CONSTANTS_INITIALIZED'
export const VUEX_CONSTANTS_SET_ALL			= 'VUEX_CONSTANTS_SET_ALL'